var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrentEmptyProjectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 70,
    fill: "#CDDCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5858 51.5858C54 52.1716 54 53.1144 54 55V85.8571C54 87.7428 54 88.6856 54.5858 89.2714C55.1716 89.8571 56.1144 89.8571 58 89.8571H82C83.8856 89.8571 84.8284 89.8571 85.4142 89.2714C86 88.6856 86 87.7428 86 85.8571V55C86 53.1144 86 52.1716 85.4142 51.5858C84.8284 51 83.8856 51 82 51H58C56.1144 51 55.1716 51 54.5858 51.5858ZM63.1429 61.4286C62.5906 61.4286 62.1429 61.8763 62.1429 62.4286C62.1429 62.9809 62.5906 63.4286 63.1429 63.4286H76.8571C77.4094 63.4286 77.8571 62.9809 77.8571 62.4286C77.8571 61.8763 77.4094 61.4286 76.8571 61.4286H63.1429ZM63.1429 70.5714C62.5906 70.5714 62.1429 71.0191 62.1429 71.5714C62.1429 72.1237 62.5906 72.5714 63.1429 72.5714H76.8571C77.4094 72.5714 77.8571 72.1237 77.8571 71.5714C77.8571 71.0191 77.4094 70.5714 76.8571 70.5714H63.1429ZM63.1429 79.7143C62.5906 79.7143 62.1429 80.162 62.1429 80.7143C62.1429 81.2666 62.5906 81.7143 63.1429 81.7143H72.2857C72.838 81.7143 73.2857 81.2666 73.2857 80.7143C73.2857 80.162 72.838 79.7143 72.2857 79.7143H63.1429Z",
    fill: "#063065"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentEmptyProjectIcon);
export default __webpack_public_path__ + "static/media/CurrentEmptyProjectIcon.dfd37326dbb72d8669e6acef1a7d5c7e.svg";
export { ForwardRef as ReactComponent };